import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

/**
 * 당겨서 새로고침 시 발화.
 * iOS `MetaFeedEventService.sendRefreshScreenEvent(screen: .liked_goods, action: .pull)` →
 * `REFRESH_SCREEN` (`ACTION: 'PULL'`). SCREEN 은 AnalyticsContext 에서 자동 주입.
 */
export const useLogRefreshScreen = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(() => {
    logAnalyticsEvent({
      name: 'REFRESH_SCREEN',
      analytics: { ACTION: 'PULL' },
    });
  }, [logAnalyticsEvent]);
};
